import { FC } from "react";
import { scroller, Element } from "react-scroll";
import { useTranslation } from "next-i18next";
import { MainContainer } from "../../styles/basicStyles";
import { CareersPageType } from "../../models/careers";
import { colors } from "../../styles/colors";
import WorkingAtCodepoint from "./components/workingAtCodepoint";
import OpenPositions from "./components/openPositions";
import GlobalBanner from "../../components/views/globalBanner";
import WeValue from "./components/weValue";
import Metatags from "../../components/metatags";

interface Props {
  data: CareersPageType;
}

const Careers: FC<Props> = ({ data }) => {
  const { t, i18n: { language } } = useTranslation();

  return (
    <>
      <Metatags
        title={data.meta_title && data.meta_title[language]}
        description={data.meta_description && data.meta_description[language]}
        keywords={data.meta_keywords && data.meta_keywords[language]}
        image={data.meta_image?.url}
      />
      <GlobalBanner
        page={data?.category && data?.category[language]}
        description={data?.description && data?.description[language]}
        bgColor={colors.chineseBlack}
        dot
        dotColor={colors.lightBlue}
        linkText={t("SEE_OPEN_POSITIONS")}
        linkUrl={() => scroller.scrollTo("openSpots", { offset: -100 })}
        origin='career'
      />
      <MainContainer>
        <WorkingAtCodepoint />
      </MainContainer>
      <WeValue />
      {data?.openSpots?.length > 0 && (
        <Element name="openSpots">
          <MainContainer>
            <OpenPositions positions={data?.openSpots} />
          </MainContainer>
        </Element>
      )}
    </>
  );
};

export default Careers;
